import { isSafari } from '@libs/utils/helpers/isSafari';
import { isIOS } from '@libs/utils/helpers/mobileOS';

import { linkBridge } from '@webview-bridge/web';

const bridge = linkBridge({
  throwOnError: true,
  timeout: 60000, // 60 seconds
});

const nativeByPassLinks = ['consumidorpositivo.com.br/produtos'];

export const redirect = (url: string) => {
  const openNativeBrowser = window.isNativeApp && !nativeByPassLinks.some((link) => url.includes(link));

  if (openNativeBrowser && bridge.isNativeMethodAvailable('linkingOpenURL')) {
    bridge.loose['linkingOpenURL'](url);
    return;
  }

  if (isIOS() || isSafari()) {
    window.location.href = url;
  } else {
    window.open(url, '_blank');
  }
};
